import { render, staticRenderFns } from "./AddOrEditPeople.vue?vue&type=template&id=a6a76ae0&scoped=true&"
import script from "./AddOrEditPeople.vue?vue&type=script&lang=js&"
export * from "./AddOrEditPeople.vue?vue&type=script&lang=js&"
import style0 from "./AddOrEditPeople.vue?vue&type=style&index=0&id=a6a76ae0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a76ae0",
  null
  
)

export default component.exports